<div *ngIf="category && visibleReports?.length > 0"
		class="print-page-break-after"
		[hidden]="!categoryVisibility.isVisible && !categoryVisibility.isPrintable"
		[ngClass]="{
				'print-hide': categoryVisibility.isVisible && !categoryVisibility.isPrintable,
				'print-only': !categoryVisibility.isVisible && categoryVisibility.isPrintable}"
>
	<div *ngIf="category.label && category.label !== ''" class="category-title"><span>{{ category.label | translate }}</span></div>
	<ng-container *ngFor="let report of visibleReports" [ngSwitch]="report?.type">
		<div
				[hidden]="!categoryVisibility.isVisible && !categoryVisibility.isPrintable"
				[ngClass]="{
					'print-hide': report.visible && !report.printable,
					'print-only': !report.visible && report.printable}"
		>
			<workflow-list-report
					*ngSwitchCase="'ListReport'"
					[report]="report" [data]="data"
			>
			</workflow-list-report>
			<workflow-content-block-report
					*ngSwitchCase="'ContentBlockReport'"
					[report]="report" [data]="data">
			</workflow-content-block-report>
			<workflow-graph-report
					*ngSwitchCase="'BfsGraphReport'"
					[report]="report" [data]="data" [containerWidth]="containerWidth">
			</workflow-graph-report>
		</div>
	</ng-container>
</div>
